'use strict';
exports = module.exports = {
  // List of user roles
  userRoles: ['guest', 'user', 'admin'],
  env: process.env.NODE_ENV,
  errors: {
    viewpoint: {
      GENERAL_ERROR: 'An error occured while creating viewpoint.',
      VIEWPOINT_TYPE_ERROR: 'Incorrect viewpoint type.',
      NOT_FOUND: 'Missing or incorrect viewpoints.',
      video: {
        VIDEO_NOT_FOUND: 'This Video has not been loaded into the site yet.'
      },
      trueview: {
        ERROR_404: 'The specified Trueview&trade; could not be found.',
        ERROR_403: 'You are not allowed to access this page.',
        ERROR_500: 'A server error has occurred.',
        ERROR_UNKOWN: 'An unknown error has occurred.',
        ERROR_LOAD_GENERAL: 'An error occured while loading the trueview',
        DUPLICATE_ASSETS: 'One or both assets are duplicated, Please upload different images.'
      }
    },
    modal: {
      GENERAL_ERROR: 'A fatal error occurred.',
      JSON_ERROR: 'Error parsing JSON'
    },
    site: {
      GENERAL_ERROR: 'An error occured while creating site.',
      SITE_LOAD_ERROR: 'An error occured while loading site.',
      FORM_INCOMPLETE: 'Please make sure all required fields are filled out correctly.'
    },
    asset: {
      UPLOAD_ERROR: 'An error occured while uploading file.'
    }
  },
  user: {
    errors: {
      TOKEN_ERROR: 'Sorry, we could not log you in because the supplied token is not valid.',
      PASSWORD_ERROR: 'Incorrect password',
      USER_UPDATE_FAIL: 'Could not update user',
      STATE_CHANGE: 'Oops, You have unsaved data! Are you sure you want to leave this page?'
    },
    PASSWORD_CHANGE: 'Password successfully changed.',
    TOKEN_AUTHENTICATION: 'Please wait while we authenticate your token.',
    AUTHENTICATION_FAIL: 'Authenticate failed'
  },
  paths: {
    ASSETS: '/client/assets/uploads/',
    IMAGES: '/assets/uploads/',
    ICONS: '/assets/icons/sectors/',
    ERROR_LOG_FILE: './server/components/errors/error.log'
  },
  viewpoints: {
    INDEXES: ['trueview', 'video'],
    TRUEVIEW: 0,
    VIDEO: 1
  },
  viewpointStates: {
    INDEXES: ['deleted', 'modified', 'new'],
    DELETED: 0,
    MODIFIED: 1,
    NEW: 2
  },
  translate: {
    ERROR: 'T_ERROR'
  },
  siteBannerIcons: {
    HIDE:'fa fa-chevron-down',
    SHOW:'fa fa-chevron-up'
  },
  report: {
    SESSIONS_PER_PAGE: 10,
    VISITED_URL: 'visited_url',
    VIDEO_PLAY: 'video_play',
    TRUEVIEW_ZOOM: 'trueview_zoom',
    HEAT_MAP_INFO: [
      'White means that portion of the video was not watched at all (the viewer skipped it)',
      'Green tells you that the viewer watched that part exactly once.',
      'Yellow means the viewer watched that part twice.',
      'Orange, light red, and dark red show that the viewer watched that part of the video three, four, or five times respectively.'
    ]
  },
  wistia: {
    api_token: 'ed3f8f4fb742801585fc14b772689c035d3e1bbffa34c3a71c2f71ac66f2cd3b',
    api_uri: 'https://api.wistia.com/v1/'
  },
  siteSectors : ['solar', 'wind', 'nuclear', 'natural_gas', 'fossils'],
  siteSectorsEnabled: false
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 72
// module chunks = 0